import React from 'react/addons';
import moment from 'ofs/moment';
import EntryPoint from 'ofs/apps/core/entry';
import initViews from './views';
import PageModel from './models/pagemodel';
import ResponsiveBreadbar from '../views/ResponsiveBreadbar';

class ArrivalEntryPoint extends EntryPoint {
  renderToDocument(document) {
    let options = this.options;

    if (!options.standalone) {
      super.renderToDocument(document);
    }

    let {formOptions, formData, contact, bookingRef} = options.prestay;

    let model = new PageModel();

    let views = initViews(formOptions);

    if (formData) {
      let eta = formData['eta'];
      let arrivalPhone = formData['arrival_phone'];

      delete formData['eta'];
      delete formData['arrival_phone'];

      formData['bookable_transfers'] = formOptions['bookable_transfers'];
      formData['num_guests'] = formOptions['num_guests'];
      model.travel.set(formData);
      model.set('arrival_phone', arrivalPhone);
      model.set('eta', eta);

      const arrival = moment(formData['arrival_time'], "YYYY-MM-DDTHH:mm");
      model.set('arrival_time', arrival.format("HH:mm:ss"), {silent: true});
      model.set('arrival_date', arrival.format("YYYY-MM-DD"), {silent: true});

      if (formData['appointment_type'] && formData['appointment_time']) {
        model.appointment.set('selected_appointment', {
          type: formData['appointment_type'],
          time: formData['appointment_time'],
        });
        model.appointment.set({
          'appointment_place_type': formData['appointment_place_type'],
          'external_location': formData['external_location'],
          'external_address': formData['external_address'],
          'external_map_link': formData['external_map_link'],
          'price_override': formData['price_override'],
        });
      }

      model.appointment.set('appointments', formOptions['suggested_appointments']);

      if (formOptions['journey_details']) {
        model.set('journey', formOptions['journey_details'].legs);
      }
    }
    const Arrivals = views.Arrivals;
    React.withContext({flux: this.flux}, () => {
      React.render(
        <Arrivals model={model} contact={contact} />,
        document.getElementById('arrivals-form')
      );
    });

    const breadbar = document.getElementById('breadbar');
    if (breadbar) {
      React.render(<ResponsiveBreadbar bookingRef={bookingRef} currentPage='book-capture-arrival' />, breadbar);
    }

  }
}

module.exports = ArrivalEntryPoint;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/arrival/entry.jsx
 **/